import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Subscription, forkJoin } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  cardGroupsNews: any[][] = [];
  isBig: boolean;
  isSmall: boolean;
  randomBackgroundColor: string = "#000000";
  hoverShadowColor: string = "#00000033";
  slides = [];
  showFullContent = false;
  showFullOverview = false;
  showFullWhy = false;
  showFullIns = false;
  showFullBuilding = false;
  showFullCulture = false;
  Notices = [];
  subscription: Subscription;
  HomeContent: any;
  MainData: any;
  GBMessages: any;
  GBMessageShown = [];

  ContentData: any;
  loadingData = true;
  constructor(
      private elementRef:ElementRef,
      private emitterService: EmitterService,
      private appService: AppService
  ) {
      this.subscription = this.emitterService.currentMessage.subscribe(
          (message) => {
              if (message === true) {
                  let mainData = localStorage.getItem("mainData");
                 
              }
          }
      );
  }

  ngOnInit() {
      this.randomBackgroundColor = this.getRandomColor();
      this.fetchHomePageData();
      this.FetchData();
  }
  ngOnDestroy() {
      if (this.subscription) {
          this.subscription.unsubscribe();
      }
  }
  FetchData() {
      forkJoin([
          this.appService.getNotices(),
          this.appService.getContents(),
          this.appService.getVideoAlbums(),
          this.appService.getImageFolders(),
          this.appService.getGBMessages(),
          this.appService.getSlides(),
      ]).subscribe((response: any) => {
          console.log(response, "response FetchData");
          this.Notices = response[0].data.filter(
            (x) => x.ShowScroll === true && x.IsActive === true
          );

          this.Notices.sort((a, b) => b.Id - a.Id);      

          this.ContentData = response[1].data;           
          this.GBMessages = response[4].data;
          console.log(this.GBMessages, "messages");
          let filteredGBM = this.GBMessages.filter((item) =>
              item.Placement.includes("1")
          );
          this.GBMessageShown = filteredGBM.slice(0, 3);
          console.log(this.GBMessageShown, "GBMessageShown");
          
      });
  }
  truncateText(text: string, maxLength: number) {
      // Remove HTML tags from the text
      const plainText = text.replace(/<[^>]*>/g, "");

      // Check if the plain text length is greater than the maximum length
      if (plainText.length > maxLength) {
          // Truncate the plain text to the maximum length and append "..." at the end
          return plainText.substring(0, maxLength) + "...";
      } else {
          // If the plain text length is within the maximum length, return the original text
          return text;
      }
  }
  getMessageHref(GBDesignationName: string): string {
    if (GBDesignationName === "Commander") {
      return "/administration/commander-message";
    } else if (GBDesignationName === "Chairman") {
      return "/administration/chairman-message";
    } else if (GBDesignationName === "Principal") {
      return "/administration/principal-messege";
    } else {
      // Default href if none of the conditions match
      return "#";
    }
  }

  toggleShowContent() {
      this.showFullContent = !this.showFullContent;
  }

  toggleShowOverview() {
      this.showFullOverview = !this.showFullOverview;
  }

  toggleShowWhy() {
      this.showFullWhy = !this.showFullWhy;
  }

  toggleShowIns() {
      this.showFullIns = !this.showFullIns;
  }

  toggleShowBuilding() {
      this.showFullBuilding = !this.showFullBuilding;
  }
  toggleShowCulture() {
      this.showFullCulture = !this.showFullCulture;
  }

  fetchHomePageData() {
      fetch("assets/json/homePage.json")
          .then((response) => response.json())
          .then((data) => {
              this.slides = data.slideImageTop;
          })
          .catch((error) => console.error("Error fetching data:", error));
  }

  @HostListener("window:resize")
  onResize() {
      this.smallScreen();
  }

  getRandomColor(): string {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
  }

  onCardHover() {
      this.hoverShadowColor = this.randomBackgroundColor;
  }

  onCardLeave() {
      this.hoverShadowColor = "#00000033";
  }

  smallScreen() {
      this.isSmall = window.innerWidth < 1300;
      this.isBig = window.innerWidth > 1300;
  }

  changeBackgroundImage(imageUrl: string) {
      const element =
          this.elementRef.nativeElement.querySelector(".bgImageTab");
      element.style.setProperty("--tab-background-image", `url(${imageUrl})`);
  }

  onNavigate(url: string) {
      window.open(`https://${url}`, "_blank");
  }

  NoAdmissionAlert() {
      alert("Admission services not open yet.");
      return;
  }
}
